<template>
  <Footer class="layout-footer-center">
    <Row type="flex" style="padding: 50px 25px" justify="space-around" :gutter="50">
      <i-col :md="{ span: 8 }" class="contact" :xs="{ span: 24 }">
        <div class="company-legacy">
          <img src="../assets/logo.png" class="logo" alt="logo" />
          <h2 class="title">
            <strong>{{ $t("companyName") }}&nbsp;{{ year }}&nbsp;&copy;</strong>
            <br />
          </h2>
        </div>
        <p>{{ $t("about_us_shorter_desc") }}</p>
        <Divider class="small-divider" />
      </i-col>
      <i-col :md="{ span: 8 }" class="info" :xs="{ span: 24 }">
        <div>
          <h2 class="margin-bottom">{{ $t("contact_and_address") }}</h2>
          <strong>
            <Icon type="ios-pin" size="24" />
            {{ $t("address") }}:
          </strong>
          {{ $t("street") }}
          <Divider class="small-divider" />
          <strong> <Icon type="ios-call" size="24" />&nbsp;Mob: </strong>
          <a :href="`tel:${$t('phone_number')}`">{{ $t("phone_number") }}</a>
          <Divider />
          <strong> <Icon type="ios-mail" size="24" />&nbsp;Email: </strong>&nbsp;
          <a :href="`mailto:${$t('email')}`" target="_blank">{{ $t("email") }}</a>
          <Divider class="small-divider" />
        </div>
        <ButtonGroup class="links">
          <Button
            name="facebook link"
            icon="logo-facebook"
            to="https://www.facebook.com/ProFinanceHome/"
            target="_blank"
            rel="noopener noreferrer"
          />
          <Button
            name="twitter link"
            icon="logo-twitter"
            to="https://twitter.com/ProFinanceHome"
            target="_blank"
            rel="noopener noreferrer"
          />
          <Button
            name="instagram link"
            icon="logo-instagram"
            to="https://www.instagram.com/profinancehome_/"
            target="_blank"
            rel="noopener noreferrer"
          />
        </ButtonGroup>
      </i-col>
      <i-col :md="{ span: 8 }" :xs="{ span: 24 }">
        <h2 class="margin-bottom">{{ $t("links") }}</h2>
        <router-link to="/services" @click.native="scrollToTop()">{{ $t("services") }}</router-link>
        <Divider class="small-divider" />

        <router-link to="/partners" @click.native="scrollToTop()">{{ $t("partners") }}</router-link>
        <Divider class="small-divider" />

        <router-link to="/about" @click.native="scrollToTop()">{{ $t("aboutus") }}</router-link>
        <Divider class="small-divider" />
        <router-link to="/branches" @click.native="scrollToTop()">{{ $t("branches") }}</router-link>
        <Divider class="small-divider" />

        <router-link to="/human-resources" @click.native="scrollToTop()">{{ $t("human_resources") }}</router-link>
        <Divider class="small-divider" />
        <router-link to="/contact" @click.native="scrollToTop()">{{ $t("contact") }}</router-link>
        <Divider class="small-divider" />
        <router-link to="/customer-care" @click.native="scrollToTop()">{{ $t("customer_care") }}</router-link>
        <Divider class="small-divider" />
        <router-link to="/CMIMORJA.pdf" target="_blank">{{ $t("pricing") }}</router-link>
        <Divider class="small-divider" />
      </i-col>
    </Row>
  </Footer>
</template>
<style lang="scss">
.layout-footer-center {
  margin: 0 15px 30px 15px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
  .ivu-divider-horizontal {
    margin: 7px 0;
  }
  .margin-bottom {
    margin-bottom: 20px;
  }
}
.info {
  div {
    font-size: 105%;
    i {
      vertical-align: top;
    }
  }
}
.contact {
  p {
    margin-top: 20px;
  }
  text-align: left;
  .company-legacy {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .logo {
      width: 80px;
      height: 80px;
      margin-right: 20px;
      display: inline-block;
    }
    .title {
      padding: 10px 0;
      display: inline;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
